import React from 'react';
import { Box, PagePanel } from 'edenred-ui';
import { connect } from 'react-redux';

import { LoadingPanelProps } from '@epi-models/components/LoadingPanel';

import { isLoading as isLoadingSelector } from '../../selectors/saga';

import './LoadingPanel.scss';

const LoadingPanel = ({
  children,
  isLoading,
  fixedWidth = false,
  ...rest
}: LoadingPanelProps) => {
  const isFunction = typeof children === 'function';

  return (
    <Box
      width={fixedWidth ? '700px' : '100%'}
      margin={fixedWidth ? 'auto' : '0'}
      className="LoadingPanel"
    >
      <PagePanel className={isLoading ? 'isLoading' : ''} {...rest}>
        {isFunction ? children({ isLoading }) : children}
      </PagePanel>
    </Box>
  );
};

const mapStateToProps = (state, props) => ({
  isLoading: Array.isArray(props.isLoading)
    ? isLoadingSelector(props.isLoading)(state)
    : props.isLoading
});

const ConnectedLoadingPanel = connect(mapStateToProps)(LoadingPanel);

export { ConnectedLoadingPanel as LoadingPanel };
